import { IInfluxAPI } from './InfluxAPIInterface';
import type { API } from '../HTTP';
import type { TimeSeriesResponse } from '../../components/TileDisplay';

export class InfluxAPI implements IInfluxAPI {
    constructor(private client: API) {}

    async postInfluxSQL({ sql }: {
        sql: string;
    }): Promise<TimeSeriesResponse> {
        const response = await this.client.post("influx-query/query", JSON.stringify({ sql }));
        const payload = (typeof response.data === 'string'
            ? JSON.parse(response.data)
            : response.data) as TimeSeriesResponse;

        if (!payload.rows || payload.rows.length === 0) {
            throw new Error("No data");
        }

        return payload;
    }
}
